import { render, staticRenderFns } from "./NewEmpleado.vue?vue&type=template&id=0dd94960&"
import script from "./NewEmpleado.vue?vue&type=script&lang=js&"
export * from "./NewEmpleado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "NewEmpleado.vue"
export default component.exports